export default {
    authNotificationsTotal_zero: 'No tienes notificaciones sin leer',
    serviceChat: {
        alert_title_closed: 'Chat Finalizado',
        alert_text_closed: 'Este chat ya no está disponible',
        alert_text_closed_by: 'El chat fue terminado por {{name}}',
        alert_title_chat_unavailable: 'Chat no Disponible',
        alert_text_chat_unavailable: 'El chat está siendo respondido por otro usuario',

        request: 'El cliente <b>{{name}}</b> está esperando ser atendido en el <b>Chat</b>',
        request_customer: 'Solicitó asistencia a través de <b>Chat</b>',
        closed: 'Su <b>Chat</b> fue cancelado por <b>{{name}}</b>',
        closed_user_agent: 'Ha finalizado su <b>Chat</b> con el cliente <b>{{name}}</b>',
        closed_user_customer: 'Terminaste tu <b>Chat</b> con el asistente <b>{{name}}</b>',
        canceled_transfer_title: 'Transferencia cancelada',
        canceled_transfer_text: 'Transferencia de chat cancelada por el usuario',
        refused_transfer_title: 'Transferencia rechazada',
        refused_transfer_text: 'El usuario rechazó la transferencia de chat',
    },
    call: {
        created: '<b>Nuevo Ticket</b> #{{number}} - <b>{{group}}</b> {{- category}} - {{subject}}',
        edited: 'Ticket #{{number}} <b>Editado</b> - <b>{{group}}</b> {{- category}} - {{subject}}',
        archived: 'Ticket <b>Archivado</b> #{{number}} - <b>{{group}}</b> {{- category}} - {{subject}}',
        sla_limit_exceeded: 'Ticket #{{number}} - <b>{{group}}</b> {{- category}} - <b>Advertencia de SLA ({{percentage}}%)</b>',
        transferred: 'Recibiste <b>{{qnt}}</b> ticket(s) - <b>{{group}}</b> - Transferido del usuario {{from}}',
    },
    attendance: {
        created: 'Ticket #{{number}} ha sido <b>respondido</b> - <b>{{group}}</b> {{- category}} - {{subject}}',
    },
    task: {
        created: '<b>Nueva Tarea</b> #{{number}} - <b>{{group}}</b> - {{subject}}',
        edited: 'Tarea #{{number}} <b>Editada</b> - <b>{{group}}</b> - {{subject}}',
        archived: 'Tarea <b>Archivada</b> #{{number}} - <b>{{group}}</b> - {{subject}}',
    },
}
